module.exports = __webpack_public_path__ + "img/antes_despues_188.6f8c1175.png";